import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function CompleteRefundBubble({
  chatMessage,
  history
}: PaymentBubbleCommonProps) {
  const totalAmount = (chatMessage?.rfq?.purchaseAmount ?? 0).toLocaleString(
    'ko'
  );
  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble error>
      <PaymentBubble.Title>환불이 완료되었습니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={2} />
      <PaymentBubble.Content>
        프로젝트가 제조 단계에서 중단됩니다. 해당 발주서의 결제 대금은 고객님께
        자동 환불됩니다.
      </PaymentBubble.Content>
      <PaymentBubble.Content>환불 대금 : {totalAmount}원</PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
